import React from "react";
import { connect } from "react-redux";

import { LoginPage } from "./LoginPage";
import { bindActionCreators } from "redux";
import { authenticationAction } from "../../_actions/authentication.action";

interface IState {
    email: string;
    password: string;
}

interface IProps {
    login(credentials:any): any;
}

class LoginForm extends React.Component<IProps, IState>
{
    constructor(props:any) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSubmit(event:any, values:any) {
        this.props.login(values);
    }

    render() {
        return (
            <>
                <LoginPage
                    handleSubmit={this.handleSubmit} />
            </>
        );
    }
}

function mapDispatchToProps(dispatch:any) {
    return bindActionCreators(
        {
            login: authenticationAction.login,
        },
        dispatch
    )
}

const LoginFormComponent = connect(null, mapDispatchToProps)(LoginForm);

export { LoginFormComponent as LoginForm};